import React, { useState, useEffect } from 'react';
import styles from './component.module.scss';
import axios from 'axios';

export function RegisterThursdayComponent({ refreshKey = 0 }: { refreshKey?: number }) {
  interface User {
    t_pseudo: string;
}

  const ep = "listRegister";
  var [user, setUser] = useState<User[]>([]);

  useEffect(() => {
    axios.get('https://labuzifpokerclub.fr/back/api/list_set.php?ep=' + ep)
      .then((response) => {
        setUser(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [refreshKey]);

  console.log(user);
 

  return (
    <div className={styles.container}>
      <h1 className={styles.title1}>Liste des inscrits ({user.length} {user.length > 1 ? 'joueurs' : 'joueur'})</h1>
      <ul className={styles.list}>
        {user.map((u) => (
          <li key={u.t_pseudo} className={styles.listItem}>
            {u.t_pseudo}
          </li>
        ))}
      </ul>
  </div>
  );
}